import { Map, List, fromJS } from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import moment from 'moment'
import ActionHelper from 'helpers/action'

// constants
export const FETCH_SITE_LIST = 'sensors/FETCH_SITE_LIST'
export const SUCCESS_SITE_LIST = 'sensors/SUCCESS_SITE_LIST'
export const FAILURE_SITE_LIST = 'sensors/FAILURE_SITE_LIST'
export const FETCH_SENSOR_TYPES = 'sensors/FETCH_SENSOR_TYPES'
export const SUCCESS_SENSOR_TYPES = 'sensors/SUCCESS_SENSOR_TYPES'
export const FAILURE_SENSOR_TYPES = 'sensors/FAILURE_SENSOR_TYPES'
export const FETCH_SENSOR_NAMES = 'sensors/FETCH_SENSOR_NAMES'
export const SUCCESS_SENSOR_NAMES = 'sensors/SUCCESS_SENSOR_NAMES'
export const FAILURE_SENSOR_NAMES = 'sensors/FAILURE_SENSOR_NAMES'
export const FETCH_SITE_TYPES = 'sensors/FETCH_SITE_TYPES'
export const SUCCESS_SITE_TYPES = 'sensors/SUCCESS_SITE_TYPES'
export const FAILURE_SITE_TYPES = 'sensors/FAILURE_SITE_TYPES'
export const RESET_ACTIVE_SENSOR_TYPES = '/sensors/RESET_ACTIVE_SENSOR_TYPES'
export const SET_ACTIVE_TYPES = 'sensors/SET_ACTIVE_TYPES'
export const RESET_ACTIVE_SENSOR_NAMES = '/sensors/RESET_ACTIVE_SENSOR_NAMES'
export const RESET_SENSOR_NAME_LIST = '/sensors/RESET_SENSOR_NAME_LIST'
export const SET_ACTIVE_NAMES = 'sensors/SET_ACTIVE_NAMES'
export const SET_ACTIVE_DATE_RANGE = 'sensors/SET_ACTIVE_DATE_RANGE'
export const FETCH_SENSORS_DATA = 'sensor/FETCH_SENSORS_DATA'
export const SET_SENSORS_CHART_LOADER = 'sensor/SET_SENSORS_CHART_LOADER'
export const SUCCESS_SENSORS_DATA = 'sensor/SUCCESS_SENSORS_DATA'
export const FAILURE_SENSORS_DATA = 'sensor/FAILURE_SENSORS_DATA'
export const RESET_SENSORS_DATA = 'sensor/RESET_SENSORS_DATA'
export const SET_CUSTOM_SENSOR_LIMITS = 'sensor/SET_CUSTOM_SENSOR_LIMITS'
export const REFRESH_SENSOR_CHART_DATA = 'sensor/REFRESH_SENSOR_CHART_DATA'

// actions
export const fetchSiteList = ActionHelper.createActionObj(FETCH_SITE_LIST)
export const fetchSensorTypes = ActionHelper.createActionObj(FETCH_SENSOR_TYPES)
export const fetchSensorNames = ActionHelper.createActionObj(FETCH_SENSOR_NAMES)
export const fetchSiteTypes = ActionHelper.createActionObj(FETCH_SITE_TYPES)
export const setActiveTypes = ActionHelper.createActionObj(SET_ACTIVE_TYPES)
export const resetActiveSensorTypes = ActionHelper.createActionObj(
  RESET_ACTIVE_SENSOR_TYPES,
)
export const setActiveNames = ActionHelper.createActionObj(SET_ACTIVE_NAMES)
export const resetActiveSensorNames = ActionHelper.createActionObj(
  RESET_ACTIVE_SENSOR_NAMES,
)
export const resetSensorNameList = ActionHelper.createActionObj(
  RESET_SENSOR_NAME_LIST,
)
export const setActiveDateRange = ActionHelper.createActionObj(
  SET_ACTIVE_DATE_RANGE,
)
export const fetchSensorsData = ActionHelper.createActionObj(FETCH_SENSORS_DATA)
export const resetSensorsData = ActionHelper.createActionObj(RESET_SENSORS_DATA)
export const setCustomSensorLimits = ActionHelper.createActionObj(
  SET_CUSTOM_SENSOR_LIMITS,
)

// store
const initialState = fromJS({
  sensorsChartLoader: false,
  sensorsTypesLoader: false,
  sensorsNamesLoader: false,
  siteListLoader: false,
  siteTypesLoader: false,
  refreshSensorData: false,
  siteList: [],
  sensorTypes: [],
  sensorNames: [],
  siteTypes: [],
  activeTypes: [],
  activeNames: [],
  dateRange: {
    startDate: moment(),
    endDate: moment(),
  },
  sensorsData: {
    dates: [],
    datasets: [],
    summary: [],
  },
})

const sensor = handleActions(
  {
    [FETCH_SITE_LIST]: state => state.set('siteListLoader', true),
    [SUCCESS_SITE_LIST]: (state, action) =>
      state.set('siteList', List(action.payload)).set('siteListLoader', false),
    [FAILURE_SITE_LIST]: state =>
      state.set('siteList', List([])).set('siteListLoader', false),

    [FETCH_SENSOR_TYPES]: state =>
      state
        .set('sensorTypes', initialState.get('sensorTypes'))
        .set('sensorsTypesLoader', true),
    [SUCCESS_SENSOR_TYPES]: (state, action) =>
      state
        .set('sensorTypes', List(action.payload))
        .set('sensorsTypesLoader', false),
    [FAILURE_SENSOR_TYPES]: state =>
      state
        .set('sensorTypes', initialState.get('sensorTypes'))
        .set('sensorsTypesLoader', false),

    [FETCH_SENSOR_NAMES]: state =>
      state
        .set('sensorNames', initialState.get('sensorNames'))
        .set('sensorsNamesLoader', true),
    [SUCCESS_SENSOR_NAMES]: (state, action) =>
      state
        .set('sensorNames', List(action.payload))
        .set('sensorsNamesLoader', false),
    [FAILURE_SENSOR_NAMES]: state =>
      state
        .set('sensorNames', initialState.get('sensorNames'))
        .set('sensorsNamesLoader', false),

    [FETCH_SITE_TYPES]: state => state.set('siteTypesLoader', true),
    [SUCCESS_SITE_TYPES]: (state, action) =>
      state
        .set('siteTypes', List(action.payload))
        .set('siteTypesLoader', false),
    [FAILURE_SITE_TYPES]: state =>
      state.set('siteTypes', List([])).set('siteTypesLoader', false),

    [SET_ACTIVE_TYPES]: (state, action) =>
      state.set('activeTypes', List(action.payload)),
    [RESET_ACTIVE_SENSOR_TYPES]: state =>
      state.set('activeTypes', initialState.get('activeTypes')),
    [SET_ACTIVE_NAMES]: (state, action) =>
      state.set('activeNames', List(action.payload)),
    [RESET_ACTIVE_SENSOR_NAMES]: state =>
      state.set('activeNames', initialState.get('activeNames')),
    [RESET_SENSOR_NAME_LIST]: state =>
      state.set('sensorNames', initialState.get('sensorNames')),
    [SET_ACTIVE_DATE_RANGE]: (state, action) =>
      state.set('dateRange', Map(action.payload)),
    [SUCCESS_SENSORS_DATA]: (state, action) =>
      state.set('sensorsData', Map(action.payload)),
    [combineActions(RESET_SENSORS_DATA, FAILURE_SENSORS_DATA)]: state =>
      state.set('sensorsData', initialState.get('sensorsData')),
    [SET_SENSORS_CHART_LOADER]: (state, action) =>
      state.set('sensorsChartLoader', Boolean(action.payload)),
    [REFRESH_SENSOR_CHART_DATA]: (state, action) =>
      state.set('refreshSensorData', action.payload),
  },
  initialState,
)

export default sensor
